exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reclamaciones-container[data-v-79821ac2]{min-height:70vh}@media (min-width:1024px){.reclamaciones-container[data-v-79821ac2]{min-height:90vh}}", ""]);

// exports
